// extracted by mini-css-extract-plugin
export default {"table":"PositionInfoDialog_table__5QoZK","right":"PositionInfoDialog_right__3AXiW","left":"PositionInfoDialog_left__1DGDl","link":"PositionInfoDialog_link__VhzNy"};